import { MARKETING_RESOURCE_CHANNELS } from "@/services/marketing";
import { RouterView, type RouteRecordRaw } from "vue-router";
export const salesRoutes: RouteRecordRaw[] = [
  {
    path: "spending-report",
    alias: "/spending-report",
    name: "spending-report",
    meta: {
      title: "Spending Report",
      text: "Spending Report",
      description: "See how your spending compares to your budget",
      added: "2021-03-23",
      icon: "money-bill-wave-light",
      requiredResources: MARKETING_RESOURCE_CHANNELS,
      helpDeskPath: "spending-report",
      breadcrumb: false,
    },
    component: () => import("@/views/SpendingReport/SpendingReport.vue"),
  },
  {
    path: "budget-tool",
    alias: "/budget-tool",
    name: "budget_tool_shell",
    redirect: { name: "budget_tool" },
    meta: {
      title: "Budget Tool",
      text: "Budget Tool",
      description: "Plan and track your marketing budgets",
      icon: "wallet",
      requiredResources: MARKETING_RESOURCE_CHANNELS,
      requiredFeatureFlag: "budgetTool",
      paywall: true,
      beta: true,
      breadcrumb: {
        label: "Budget Tool",
        to: { name: "budget_tool" },
      },
    },
    component: RouterView,
    children: [
      {
        path: "",
        name: "budget_tool",
        meta: { title: "Budget Tool", breadcrumb: false },
        component: () => import("@/views/BudgetTool/BudgetTool.vue"),
      },
      {
        path: ":id",
        name: "budget_tool_detail",
        meta: {
          title: "Budget Tool",
          excludeFromNavbar: true,
          breadcrumb: {
            label: "Budget plan",
            dynamic: true,
            fallback: "Budget plan",
          },
        },
        component: () => import("@/views/BudgetTool/BudgetPlanDetail.vue"),
      },
    ],
  },
];

export const publicBudgetRoute: RouteRecordRaw[] = [
  {
    path: "shared-budget/:token",
    name: "shared_budget",
    meta: {
      activityArea: null,
      publicShare: "always",
      title: "Shared Budget",
      requiresAuth: false,
      shell: "reader",
      navbar: "hidden",
      sidepanel: "hidden",
      contentWidth: "full-bleed",
      breadcrumb: false,
      // No requiredFeatureFlag here — the public share endpoint enforces the
      // flag server-side using the plan's org, returning 404 when disabled.
      // A client-side gate would have nowhere to read user/org context from.
    },
    component: () => import("@/views/BudgetTool/SharedBudgetView.vue"),
  },
];
